/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import { NAVIGATION_UI_STORAGE_KEY } from './navigationUiStorageKey.constants.tsx';
import type { UIControllerShape } from './UIControllerShape.types.tsx';
import { queryLocalStorage, updateLocalStorageData } from './queryLocalStorage.tsx';

export const getNavigationUiState = async ({
	tenantContext,
}: {
	tenantContext: {
		readonly atlassianAccountId: TenantContext['atlassianAccountId'];
	};
}): Promise<UIControllerShape | undefined> => {
	const { atlassianAccountId: accountId } = tenantContext;
	let uiState = await queryLocalStorage();

	if (uiState || !accountId) {
		return uiState;
	}

	try {
		uiState = await getUserProperty(accountId, NAVIGATION_UI_STORAGE_KEY);
		// @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
		updateLocalStorageData(uiState);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		// Don't log the error on purpose. This is very frequent for some reason :(
	}

	return uiState;
};
